'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OtherIcon = function OtherIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '40',
                cy: '40',
                r: '40'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M10 55.034h60v-1.187H10zM10 58h60v-1.186H10z'
                })
            ),
            _react2.default.createElement('path', {
                d: 'M34.084 47.413H46.58c1.007-1.741 1.556-3.255 1.645-4.542.075-1.086-.023-2.92-.294-5.499l-3.437-5.869c.507-2.75.893-4.619 1.158-5.603.265-.985.575-1.896.928-2.733H33.956c-.948 2.209-1.447 4.212-1.497 6.01-.032 1.155.295 2.79.982 4.904l2.261 3.291.743 5.659-2.361 4.382z',
                fill: '#FFF'
            }),
            _react2.default.createElement('path', {
                d: 'M33.064 29.465a8.45 8.45 0 0 1 1.815-5.246.765.765 0 0 0-.097-1.049.701.701 0 0 0-1.011.1 9.982 9.982 0 0 0-2.144 6.195c0 2.276.774 4.49 2.177 6.236a8.447 8.447 0 0 1 1.844 5.28 8.446 8.446 0 0 1-1.815 5.246.765.765 0 0 0 .097 1.049.702.702 0 0 0 1.011-.1 9.979 9.979 0 0 0 2.144-6.194 9.972 9.972 0 0 0-2.177-6.236 8.442 8.442 0 0 1-1.844-5.281M39.02 29.465c0-1.911.645-3.775 1.815-5.246a.764.764 0 0 0-.097-1.049.7.7 0 0 0-1.011.1 9.98 9.98 0 0 0-2.144 6.195c0 2.276.774 4.49 2.177 6.236a8.446 8.446 0 0 1 1.844 5.28 8.445 8.445 0 0 1-1.815 5.246.765.765 0 0 0 .096 1.049.702.702 0 0 0 1.012-.1 9.979 9.979 0 0 0 2.144-6.194 9.975 9.975 0 0 0-2.178-6.236 8.442 8.442 0 0 1-1.843-5.281M46.82 34.746a8.446 8.446 0 0 1-1.844-5.281c0-1.911.644-3.775 1.815-5.245a.764.764 0 0 0-.097-1.05.7.7 0 0 0-1.012.101 9.979 9.979 0 0 0-2.143 6.194c0 2.277.774 4.491 2.177 6.236a8.446 8.446 0 0 1 1.844 5.281 8.446 8.446 0 0 1-1.816 5.245.765.765 0 0 0 .098 1.05.699.699 0 0 0 1.01-.101 9.977 9.977 0 0 0 2.144-6.194c0-2.277-.773-4.491-2.177-6.236',
                fill: '#555'
            })
        )
    );
};

OtherIcon.defaultProps = {
    width: '80',
    height: '80',
    viewBox: '0 0 80 80',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Other = function (_React$Component) {
    _inherits(Other, _React$Component);

    function Other() {
        _classCallCheck(this, Other);

        return _possibleConstructorReturn(this, (Other.__proto__ || Object.getPrototypeOf(Other)).apply(this, arguments));
    }

    _createClass(Other, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(OtherIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return Other;
}(_react2.default.Component);

exports.default = Other;